﻿import onReady from '../utils/onReady';
import * as responsiveWindow from '../utils/responsiveWindow';
import triggerCustomEvent from '../utils/triggerCustomEvent';
import domIterator from '../utils/domIterator';
import * as Events from '../utils/events';


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class Minibasket {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {
        this.dom = {
            container, // ES6 allows this syntax instead of writing "container: container"
            basketlink: document.querySelector(".mymenu__basket"),
            minibaset: document.querySelector(".basket__minibasket"),
            addToBasketButtons: document.querySelectorAll(".addToBasket")
        };

        this.showsectionurl = this.dom.container.getAttribute("data-showsectionurl");
        if (!this.showsectionurl) {
            this.showsectionurl = "/boligsogende/boligvisning"; // Fallback
        }

        Events.addEvent(this.dom.basketlink, "mouseover", (i) => {
            let basketsize = this.dom.container.parentElement.querySelector("[data-basketsize]").getAttribute("data-basketsize");
            if (basketsize != "0" && basketsize != "") {
                this.dom.basketlink.classList.add('navigation__link--active');
            }
            else {
                //console.log("Kurven er tom. Viser ikke minibasket");
            }
        });
        Events.addEvent(this.dom.basketlink, "mouseleave", (i) => {
            this.dom.basketlink.classList.remove('navigation__link--active');
        });
        Events.addEvent(this.dom.container, "loadcontent", this.loadContent.bind(this));
        this.triggerButtons = true;

        this.loadContent();
    }

    // hideBubble() {
    //     /* Hack to hide the blue ball after the shopping basket, if the basket is empty */
    //     var notificationsBall = document.createElement("style");
    //     notificationsBall.innerHTML =
    //         `.mymenu__basket a > .icon:after,
    //         .bottom-nav__content .icon--basket:before {
    //         content: attr(data-basketsize);
    //         position: absolute;
    //         right: 4px;
    //         top: -7px;
    //         background-color: ;
    //         border-radius: 50%;
    //         width: 18px;
    //         height: 18px;
    //         line-height: 18px;
    //         text-align: center;
    //         font-size: 11px;
    //         font-weight: 100;
    //         color: white;
    //         }`;

    //     document.head.appendChild(notificationsBall);
    //     /* END of hack */
    // }

    loadContent() {
        let url = "/api/managebasket/getoverlaybasketcontent";
        let method = "get";

        var request = new XMLHttpRequest();
        request.open(method, url, true);

        request.onload = function() {


          if (request.status >= 200 && request.status < 400) {
            // Success!
            var data = JSON.parse(request.responseText);
            let basketsize = 0;

            if (!data)  {
                [].forEach.call(document.querySelectorAll("[data-basketsize]"), (b) => {
                    b.setAttribute("data-basketsize","0");
                    b.setAttribute("aria-label", `Min kurv`);
                });
                return;
            }

            basketsize = (data.length? data.length : "0");
            [].forEach.call(document.querySelectorAll("[data-basketsize]"), (b) => {
                b.setAttribute("data-basketsize",basketsize);
                b.setAttribute("aria-label", `Min kurv, indeholder ${basketsize} boligopskrivning`);
            });

            let listingsHtml = "";

            // Full address here if needed
            // ${x.Section.Addresses[0].Address1}<br> ${x.Section.Addresses[0].Zip} ${x.Section.Addresses[0].Town}

            [].forEach.call(data, x => {
                let sectionUrl = `${this.showsectionurl}?id=${x.SectionId}`;
                let template = `
                            <a href="${sectionUrl}" class="basket__minibasket-listing">
                                <div class="row ">
                                    <div class="sm-6">
                                        <div style="max-width: 70px; max-height: 70px; position: relative;">
                                            <img src="${x.Section.ImageUrl}" />
                                        </div>
                                    </div>
                                    <div class="sm-14">
                                        <h5>${x.Section.Name}</h5>
                                        <p>${x.Section.Addresses[0].Zip} ${x.Section.Addresses[0].Town} </p>

                                    </div>
                                    <div class="sm-4">
                                        <div class="textlink">

                                            <div class="textlink__content">
                                                <p class="textlink__text">

                                                </p>
                                                <div class="button button--static">
                                                    <div class="button__text"></div>
                                                    <div class="button__icon icon icon--arrow">
                                                        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
                                                            <path d="M0-.25h24v24H0z" fill="none"/>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </a>

                            `;

                listingsHtml += template;
            });

            this.dom.container.querySelector(".basket__minibasket-listings").innerHTML = listingsHtml;

            if (this.triggerButtons) {
                domIterator(this.dom.addToBasketButtons, element => {
                    triggerCustomEvent(element, "basket-status", data);
                });

                // We only need to trigger buttons on load
                this.triggerButtons = false;
            }

            } else {
                console.log("Error fetching items for display in the minibasket (1)");
            }
        }.bind(this);

        request.onerror = function() {
            console.log("Error fetching items for display in the minibasket (2)");
        };

        request.send();
    }

}


export default Minibasket;
